import { EPodkladAktivum } from 'enums/isin/udaje/podkladAktivum';

const podkladAktivumSelect = [
    {
        value: EPodkladAktivum.K,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_KA'
    },
    {
        value: EPodkladAktivum.A,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_A'
    },
    {
        value: EPodkladAktivum.DN,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_DN'
    },
    {
        value: EPodkladAktivum.KM,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_K'
    },
    {
        value: EPodkladAktivum.M,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_M'
    },
    {
        value: EPodkladAktivum.I,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_I'
    },
    {
        value: EPodkladAktivum.O,
        labelcz: 'ISIN_EMISE_WARRANT_PODKLAD_O'
    }
];
export default podkladAktivumSelect;
